import {useEffect, useState} from 'react';
import {Trans} from '@common/i18n/trans';
import { Button } from '@common/ui/buttons/button';
import { useReLoanProgramAction } from './requests/use-re-check-loan-program-action';

type ReExecuteLoanProgramActionProps = {
  id: number|string,
  meta_header: string;
  files: any;
};
export function ReLoanProgramAction( {id, meta_header, files}: ReExecuteLoanProgramActionProps) {
  const reExecuteLoanProgramAction = useReLoanProgramAction(id, meta_header, files);

const [fileName, setFileName] = useState('');

  useEffect(() => {
    if (files && files.name) {
      setFileName(files.name);
    } else if (files && files.filename) {
      setFileName(files.filename);
    }
  }, [files]);

  return (
    <>
      <Button
        size={'xs'} variant="flat" color="orange"
        type="submit"
        onClick={() => {
          reExecuteLoanProgramAction.mutate(
            {id: id, meta_header: meta_header, files: files},
            {
              onSuccess: (response) => {
                //onProcess(response.status, response.total_files, response.uploaded_date, response.file_name);
              },

            },
          );
        }}
        disabled={!fileName || reExecuteLoanProgramAction.isPending}
        >
        <Trans message={`Re-Upload Loan Program`} />
      </Button>
    </>

  );
}
